import Vue from 'vue';
import i18n from '@/i18n';
import { Toast } from 'vant';
Vue.use(Toast);

let loading;
//loading发起时加的计数锁
let loadingCount = 0; 
//定时器增加的数值
let numberCount = 0; 
//定时器
let timer = null; 
//超时时间值(秒)
const loadingTime = 15; 

const startLoading = (state) => {
  loading = Toast.loading({
    // 持续展示 toast
    duration: 0,    
    // 禁用背景点击   
    forbidClick: true, 
    //是否显示背景遮罩层
    mask: true, 
    loadingType: 'spinner',
    message: state.text
  });
  //允许同时存在多个 Toast
  Toast.allowMultiple(); 

  if (state.time){
    setTimeout(() => {
      endLoading();
      loadingCount = 0;
    }, state.time);
  }

  // 超时关闭loading
  timer = setInterval(() => {
    numberCount++;
    if (numberCount > loadingTime){
      endLoading();
      loadingCount = 0;
    }
  }, 1000);
};

const endLoading = () => {
  loading.clear();
  // 接除timer
  clearInterval(timer);
  numberCount = 0;
};

export const showLoading = (state) => {
  if (loadingCount === 0) {
    startLoading(state || {
      text: i18n.t('app.正在加载'),
      time: ''
    });
  }
  loadingCount += 1;
};

export const hideLoading = () => {
  if (loadingCount <= 0) {
    return;
  }
  loadingCount -= 1;
  if (loadingCount === 0) {
    endLoading();
  }
};
